import React, { useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import { useForm } from "../../provider/Form/FormProvider";
import { FormHelperText } from "@mui/material";
import _get from "lodash/get";
import { formValue } from "../../services/formServiceFunctions";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";
import { ValidatorType } from "../../types/ValidatorType";
import dayjs from "dayjs";

type ValidatorDateFieldProps = {
  name: string;
  label: string;
  helperText?: string | null;
  validators?: ValidatorType[];
  dependentValidationFields?: string[];
} & Omit<DatePickerProps, "value" | "onChange" | "label" | "renderInput">;

export default function ValidatorDateField({
  name,
  label,
  helperText,
  validators = [],
  dependentValidationFields = [],
  ...rest
}: ValidatorDateFieldProps) {
  const { values, errors, setError, handleChange, registerValidators }: any = useForm();

  const error = !!_get(errors, name);
  useEffect(() => {
    registerValidators(name, validators, dependentValidationFields);
    return () => {
      registerValidators(name, [], []);
      setError(name, undefined);
    };
  }, [name]);

  const currentFormValue = formValue(values, name);

  return (
    <FormControl fullWidth sx={{ margin: "1rem 0 .3rem 0" }}>
      <DatePicker
        value={currentFormValue ? dayjs(currentFormValue) : null}
        slotProps={{
          textField: {
            name: name,
            error: error,
          },
        }}
        onChange={(date) => handleChange({ target: { name: name, value: date } })}
        label={label}
        {...rest}
      />
      <FormHelperText sx={_get(errors, name) ? { color: "error.main" } : {}} role={_get(errors, name) ? "alert" : undefined}>
        {_get(errors, name) || helperText}
      </FormHelperText>
    </FormControl>
  );
}
